// import loader from '../../images/assets/loader.svg';
import style from './simpleloader.module.scss';

const SimpleLoader = ( { width = 60 } ) => {
    return (
        <div className={style.loader_background}>
            <div className={style.loader} style={{width:`${width}px`,height:`${width}px`}}></div>
        </div>
    );
}

export default SimpleLoader;
